<template>
  <section class="hero-banner-section">
    <div id="carouselExample" class="carousel slide hero-carousel">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          v-for="(slider, index) in imageSliders"
          :key="slider.id"
          :class="{ active: index === 0 }"
        >
          <div class="hero-slide">
            <div class="hero-image-shell" :class="{ 'is-loaded': loadedSlides[slider.id] }">
              <div v-if="!loadedSlides[slider.id]" class="hero-image-skeleton"></div>
              <img
                :src="getImageUrl(slider.url)"
                class="d-block w-100 image-slider"
                alt="Khaing Parami banner"
                :loading="index === 0 ? 'eager' : 'lazy'"
                :fetchpriority="index === 0 ? 'high' : 'auto'"
                decoding="async"
                @load="markSlideLoaded(slider.id)"
              />
              <div class="container hero-content">
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div class="container hero-stats-wrap">
      <div class="hero-stats-card">
        <div class="hero-stat-item">
          <div class="hero-stat-icon">
            <i class="fas fa-users"></i>
          </div>
          <h3 class="hero-stat-number">{{ facts.total_students ? facts.total_students : 0 }}+</h3>
          <p class="hero-stat-label">{{ $t("happyStudents") }}</p>
        </div>
        <div class="hero-stat-item">
          <div class="hero-stat-icon">
            <i class="fas fa-user-graduate"></i>
          </div>
          <h3 class="hero-stat-number">{{ facts.total_teachers ? facts.total_teachers : 0 }}</h3>
          <p class="hero-stat-label">{{ $t("expertTeachers") }}</p>
        </div>
        <div class="hero-stat-item">
          <div class="hero-stat-icon">
            <i class="fas fa-calendar-check"></i>
          </div>
          <h3 class="hero-stat-number">{{ facts.total_events ? facts.total_events : 0 }}+</h3>
          <p class="hero-stat-label">{{ $t("eventsComplete") }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mediaUrl from "../utils/mediaUrl";

export default {
  data() {
    return {
      loadedSlides: {},
    };
  },
  methods: {
    getImageUrl(imageUrl) {
      return mediaUrl(imageUrl);
    },
    markSlideLoaded(id) {
      this.$set(this.loadedSlides, id, true);
    },
    ...mapActions(["getImageSlider", "getFacts"]),
  },
  computed: mapGetters(["imageSliders", "facts"]),
  mounted() {
    this.getImageSlider();
    this.getFacts();
  },
};
</script>

<style scoped>
.hero-banner-section {
  position: relative;
  padding-bottom: 126px;
  background: linear-gradient(180deg, #ffffff 0%, #f7f7fb 100%);
}

.hero-carousel {
  position: relative;
  overflow: hidden;
}

.hero-slide {
  position: relative;
}

.hero-image-shell {
  position: relative;
  height: clamp(340px, 40vw, 560px);
  background: #ebeef5;
  overflow: hidden;
}

.hero-image-shell.is-loaded .image-slider {
  opacity: 1;
}

.hero-image-skeleton {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 50%, #eef2f7 75%);
  background-size: 200% 100%;
  animation: heroShimmer 1.5s infinite;
}

.image-slider {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  z-index: 2;
  background:
    linear-gradient(90deg, rgba(31, 14, 53, 0.78) 0%, rgba(31, 14, 53, 0.45) 34%, rgba(31, 14, 53, 0.12) 68%, rgba(31, 14, 53, 0.2) 100%);
}

.hero-content {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
}

.hero-title {
  margin-bottom: 18px;
  font-size: clamp(2.4rem, 4vw, 4rem);
  font-weight: 800;
  line-height: 1;
  color: #ffffff;
}

.hero-card {
  max-width: 540px;
  padding: 32px 34px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 28px;
  background: rgba(17, 11, 31, 0.36);
  backdrop-filter: blur(14px);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.18);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.hero-description {
  max-width: 430px;
  margin: 0 0 24px;
  font-size: 1.05rem;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.88);
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
}

.hero-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 140px;
  padding: 12px 20px;
  border-radius: 999px;
  font-size: 0.98rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.2s ease;
}

.hero-btn--primary {
  background: #ffffff;
  color: #3f0f67;
}

.hero-btn--primary:hover {
  color: #3f0f67;
  transform: translateY(-1px);
}

.hero-btn--ghost {
  border: 1px solid rgba(255, 255, 255, 0.28);
  color: #ffffff;
}

.hero-btn--ghost:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 18px;
}

.hero-meta__item {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.92rem;
  font-weight: 600;
}

.hero-stats-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  z-index: 3;
}

.hero-stats-card {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  padding: 10px 26px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 30px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(12px);
}

.hero-stat-item {
  text-align: center;
  padding: 18px 20px 14px;
}

.hero-stat-item:not(:last-child) {
  border-right: 1px solid #edf1f6;
}

.hero-stat-icon {
  margin-bottom: 12px;
  font-size: 1.85rem;
  color: #2b6f81;
}

.hero-stat-number {
  margin-bottom: 8px;
  font-size: clamp(1.9rem, 2.8vw, 2.8rem);
  font-weight: 800;
  color: #3f0f67;
}

.hero-stat-label {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #4b5563;
}

.carousel-control-prev,
.carousel-control-next {
  width: 8%;
}

@media (max-width: 991px) {
  .hero-banner-section {
    padding-bottom: 88px;
  }

  .hero-image-shell {
    height: clamp(420px, 70vw, 560px);
  }

  .hero-stats-wrap {
    position: relative;
    bottom: auto;
    margin-top: -22px;
  }

  .hero-stats-card {
    grid-template-columns: repeat(3, 1fr);
    padding: 8px 12px;
  }

  .hero-stat-item {
    padding: 16px 10px 12px;
  }

  .hero-stat-number {
    font-size: 2rem;
  }

  .hero-card {
    max-width: 480px;
    padding: 28px;
  }
}

@media (max-width: 576px) {
  .hero-banner-section {
    padding-bottom: 34px;
  }

  .hero-image-shell {
    height: clamp(220px, 62vw, 320px);
  }

  .hero-overlay {
    background: linear-gradient(180deg, rgba(31, 14, 53, 0.06) 0%, rgba(31, 14, 53, 0.1) 100%);
  }

  .hero-stats-wrap {
    margin-top: -18px;
  }

  .hero-stats-card {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    padding: 8px 4px;
    border-radius: 20px;
  }

  .hero-stat-item {
    padding: 14px 4px 12px;
  }

  .hero-stat-item:not(:last-child) {
    border-right: 1px solid #edf1f6;
    border-bottom: 0;
  }

  .hero-stat-icon {
    margin-bottom: 8px;
    font-size: 1.25rem;
  }

  .hero-stat-number {
    font-size: 1.6rem;
  }

  .hero-stat-label {
    font-size: 0.74rem;
    line-height: 1.25;
  }

  .hero-content {
    display: none;
  }
}

@keyframes heroShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
